import type { ShiftProductionFormListItem } from "../../../shared/shift-production-form/contracts";

/** Separate the daily review from overdue records without losing undated or future records. */
export function partitionApprovalQueue(items: ShiftProductionFormListItem[], now = new Date()) {
  const today = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Istanbul", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
  const previousDay = new Date(Date.parse(`${today}T00:00:00Z`) - 86_400_000).toISOString().slice(0, 10);
  const daily: ShiftProductionFormListItem[] = [];
  const overdue: ShiftProductionFormListItem[] = [];
  const other: ShiftProductionFormListItem[] = [];
  for (const item of items) {
    if (item.productionDate === previousDay) daily.push(item);
    else if (item.productionDate && item.productionDate < previousDay) overdue.push(item);
    else other.push(item);
  }
  return { previousDay, daily, overdue, other };
}
